import { Routes, Route } from "react-router-dom";
import { ClientRegister } from "../pages/ClientRegister";
import { Clients } from "../pages/Clients";
import { Configurations } from "../pages/Configurations";
import { Dashboard } from "../pages/Dashboard";
import { Login } from "../pages/Login";
import { Logs } from "../pages/Logs";
import { MessageTrigger } from "../pages/MessageTrigger";
import { Navbar } from "../pages/Navbar";
import { Profile } from "../pages/Profile";
import PrivateRoutes from "./PrivateRoutes";
import { Queue } from "../pages/Queue";
import { Users } from "../pages/Users";

const RoutesComponent = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register/:id" element={<ClientRegister />} />

      <Route path="/nav" element={<Navbar />} />
      <Route path="/" element={<PrivateRoutes type="USER,CLIENT" />}>
        <Route path="/" element={<Navbar />}>
          <Route path="" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="clients" element={<PrivateRoutes type="USER,CLIENT" />}>
            <Route path="" element={<Clients />} />
          </Route>
          <Route path="profile" element={<Profile />} />
          <Route path="logs" element={<Queue />} />
          <Route path="message" element={<MessageTrigger />} />
          <Route path="queue" element={<Queue />} />
          <Route path="configurations" element={<Configurations />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default RoutesComponent;
